<template>
    <div>
        <div style="width:900px;">           
            <div class="profile-content">
                <div class="avatar-section">
                    <div class="avatar-container">
                        <img :src="form.photo" alt="用户照片" id="avatar-img">
                    </div>
                    
                    <h2 class="user-name">{{ form.name }}</h2>
                    <p class="user-title">{{ form.company }}</p>
                </div>
                
                <div class="info-section">
                    <div class="info-grid">
                        <div class="info-item">
                            <div class="info-label"><i class="el-icon-office-building"></i>履历公司</div>
                            <div class="info-value">{{ form.company }}</div>
                        </div>
                        <div class="info-item">
                            <div class="info-label"><i class="el-icon-s-cooperation"></i>职位</div>
                            <div class="info-value">{{ form.position }}</div>
                        </div>
                    </div>
                    <div class="bio-section">
                        <div class="bio-label"><i class="el-icon-data-analysis"></i>擅长领域</div>
                        <div class="bio-content">{{ form.fields }}</div>
                    </div>
                    <div class="bio-section">
                        <div class="bio-label"><i class="el-icon-s-marketing"></i>擅长行业</div>
                        <div class="bio-content">{{ form.industries }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";

export default {
    created() {
        if(this.$route.query.id){
            this.user_id = this.$route.query.id;
            this.queryExpertInfo();
        }else{
            this.$router.push({
                path: '/404',
            });
        }
        // this.queryExpertInfo();
    },
    data() {
        return {
            user_id: null,
            form: {},
        }
    },
    methods: {
        queryExpertInfo() {
            let params;
            params = {
                'id': this.user_id,
            } 
            getdata.getListP("queryExpertInfo", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.form = resp.data.data;
                }else{
                    this.$router.push({
                        path: '/404',
                    });
                }
            })
            .catch(err => {
                this.$router.push({
                    path: '/404',
                });
            });
        },
    }
}
</script>

<style scoped>
::v-deep .el-form-item__label {
    font-size: 16px;
}
::v-deep .el-form-item__content {
    font-size: 16px;
    text-align: left;
}
.profile-content {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    margin-top: 50px;
    margin-left: 50px;
}

.avatar-section {
    flex: 1;
    min-width: 300px;
}

.info-section {
    flex: 2;
    min-width: 300px;
}

.avatar-container {
    width: 200px;
    height: 200px;
    margin: 0 auto 20px;
    border-radius: 50%;
    overflow: hidden;
    border: 4px solid #e8f4fc;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    position: relative;
}

.avatar-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.avatar-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 300px;
    margin: 0 auto;
}
.form-group {
    margin-bottom: 20px;
    text-align: left;
}

label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #2c3e50;
}

input, textarea, select {
    width: 220px;
    padding: 12px;
    border: 2px solid #e1e8ed;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.3s;
}

input:focus, textarea:focus, select:focus {
    border-color: #3498db;
    outline: none;
}

/* 不可编辑字段的样式 */
input:read-only, textarea:read-only, select:read-only {
    background-color: #f8f9fa;
    color: #6c757d;
    cursor: not-allowed;
    border-color: #e9ecef;
}

textarea {
    width: 490px;
    /* min-height: 120px; */
    resize: vertical;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 25px;
}

.info-item {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    border-left: 4px solid #3498db;
    transition: transform 0.3s ease;
}

.info-item:hover {
    transform: translateY(-5px);
}

.info-label {
    font-size: 0.9rem;
    color: #7f8c8d;
    margin-bottom: 8px;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.info-label i {
    margin-right: 10px;
    color: #3498db;
}

.info-value {
    font-size: 1.2rem;
    color: #2c3e50;
    font-weight: 500;
    word-break: break-word;
    text-align: left;
}

.bio-section {
    margin-top: 30px;
    padding: 25px;
    background: #f8f9fa;
    border-radius: 12px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.bio-label {
    font-size: 1.2rem;
    color: #2c3e50;
    margin-bottom: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.bio-label i {
    margin-right: 10px;
    color: #3498db;
}

.bio-content {
    color: #34495e;
    line-height: 1.8;
    font-size: 1.1rem;
    text-align: left;
}

.form-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.form-row .form-group {
    flex: 1;
    min-width: 250px;
}
.modal {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1000;
    align-items: center;
    justify-content: center;
}

.modal.active {
    display: flex;
}

.modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 700px;
    padding: 25px;
    position: relative;
}

.close-modal {
    position: absolute;
    top: 15px;
    right: 15px;
    font-size: 28px;
    cursor: pointer;
    color: #777;
}

.close-modal:hover {
    color: #333;
}

.crop-container {
    width: 100%;
    height: 400px;
    margin: 20px 0;
    background: #f8f9fa;
    overflow: hidden;
}

.crop-actions {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    margin-top: 20px;
}

.file-input {
    display: none;
}

.requirements {
    font-size: 0.9rem;
    color: #7f8c8d;
    margin-top: 5px;
}

@media (max-width: 768px) {
    .profile-content {
        flex-direction: column;
    }
    
    .avatar-container {
        width: 150px;
        height: 150px;
    }
    
    h1 {
        font-size: 2rem;
    }
}
</style>
